var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-layout',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('sakali-header',{attrs:{"title":"TeamAndCoachSearchTest"}})]},proxy:true},{key:"main",fn:function(){return [_vm._v(" Team oder Trainer suchen "),_c('team-and-coach-search-input'),_vm._v(" Testtext, um zu sehen, dass combo als overlay kommt ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }